import APICall from "../utils/APICall";

export default class TransferServices {
  static listTransfers = async (
    page,
    pageLimit,
    search,
    from,
    to,
    transferStatus,
    transferType
  ) => {
    var url = `/api/Transfer/admin/listTransfers?page=${page}&pageLimit=${pageLimit}`;
    if (search) url = `${url}&search=${search}`;
    if (from) url = `${url}&from=${from}`;
    if (to) url = `${url}&to=${to}`;
    if (transferStatus) url = `${url}&transferStatus=${transferStatus}`;
    if (transferType) url = `${url}&transferType=${transferType}`;
    return await APICall(url, "GET");
  };

  static viewTransfer = async (transferId) => {
    return await APICall(
      `/api/Transfer/admin/viewTransfer/${transferId}`,
      "GET"
    );
  };
  static exportTransfers = async (
    search,
    from,
    to,
    transferStatus,
    transferType
  ) => {
    return await APICall(
      `/api/Transfer/admin/export-transfer?search=${search}&from=${from}&to=${to}&transferStatus=${transferStatus}&transferType=${transferType}`,
      "GET"
    );
  };
  static summary = async () => {
    return await APICall("/api/Transfer/admin/get-transfer-summary", "GET");
  };
  // beneficiaries
  static listBeneficiares = async (page, pageLimit, search, from, to) => {
    return await APICall(
      `/api/Beneficiary/admin/list-beneficiaries?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}`,
      "GET"
    );
  };
  static exportBeneficiaries = async (search, from, to) => {
    return await APICall(
      `/api/Beneficiary/admin/export-beneficiaries?search=${search}&from=${from}&to=${to}`,
      "GET"
    );
  };
}
